module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.1d3eb5d6.svg";